import { atom, useAtom } from 'jotai';

// bool for toggling the side FAQ
export const toggleQuestionAtom = atom(true);

export function useQuestionToggleAtom() {
  return useAtom(toggleQuestionAtom);
}
